export const HostTypes = {
    Classic: 'classic',
    Editorx: 'editorx',
};
export const ConsumerTypes = {
    PanelBuilder: 'panel-builder',
    Internal: 'internal',
};
export const ApiVersions = {
    V1: 'v1',
    V2: 'v2',
};
export function definePlatformAPI(creator) {
    return creator;
}
// NOTE:
// INamespaceCreatorCallback is used to hint return types inside callback
// INamespaceCreatorReturnType is used to type hint the return type and it infers correct type from generic
// but in fact those two are the same
export function defineNamespace(namespaceCreator) {
    return namespaceCreator;
}
//# sourceMappingURL=common.js.map